const objectsEqual = (a: any, b: any) =>
  JSON.stringify(a) === JSON.stringify(b);
export const getChangedFields = (values: any, initialValues: any) =>
  Object.fromEntries(
    Object.entries(values).filter(
      ([key, val]) => !objectsEqual(val, initialValues[key]),
    ),
  );
